export const projectDesignationTypeOptions = [
  { value: "ONSHORE", label: "Onshore" },
  { value: "OFFSHORE", label: "Offshore" },
];

export const designationOptionsForType = (options, locationType) =>
  locationType
    ? options.filter((option) => option.locationType === locationType).map((option) => ({
        ...option,
        label: option.label.replace(/\s+\((?:Onshore|Offshore)\)$/i, ""),
      }))
    : [];
